import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Comprehensive ResizeObserver error suppression
// These errors are harmless and don't affect functionality
const suppressResizeObserverErrors = () => {
  // Patch the error before anything else loads
  const originalError = console.error;
  console.error = (...args) => {
    const firstArg = args[0];
    if (
      (typeof firstArg === 'string' && firstArg.includes('ResizeObserver')) ||
      (firstArg?.message && firstArg.message.includes('ResizeObserver'))
    ) {
      return;
    }
    originalError.apply(console, args);
  };

  // Suppress in window error events - multiple handlers for redundancy
  const errorHandler = (e) => {
    if (
      e.message?.includes('ResizeObserver') ||
      e.error?.message?.includes('ResizeObserver') ||
      e.filename?.includes('ResizeObserver')
    ) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  };
  
  window.addEventListener('error', errorHandler, true);
  window.addEventListener('error', errorHandler, false);

  // Suppress unhandled promise rejections
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message?.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  });

  // Override global error handler to catch errors before React error boundary
  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (
      (typeof message === 'string' && message.includes('ResizeObserver')) ||
      error?.message?.includes('ResizeObserver')
    ) {
      return true; // Prevent default error handling
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };
};

// Apply suppression immediately before anything else
suppressResizeObserverErrors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
